import { produce } from 'immer';

import { OpenCampaignServiceEditor } from '../../actions/campaignServiceEditor/openCampaignServiceEditor';
import { CampaignServiceEditorState } from '../../typings/campaignServiceEditor';

export function openCampaignServiceEditor(
    state: CampaignServiceEditorState,
    action: OpenCampaignServiceEditor
): CampaignServiceEditorState {
    return produce(state, draft => {
        const { editorId } = action;

        draft[editorId].isOpen = true;
    });
}
